import { GetTimeFromTimestamp, TextTemplateResponseObject, UglImportTask } from '@dave/types';


export class  TextTemplateEntity {
    constructor(
        public Id: number = null,
        public Name: string = null,
        public Content: string = null,
        public UserId: number = null,
        public PartnerId: number = null,
        public Private: boolean = null,
        public TagIds: string[] = null,
        public UpdatedAt: Date = null,
        public CreatedAt: Date = null,
        public DeletedAt: Date = null,
    ) {}

    public static EntityName = 'TextTemplateEntity';
    public Clone(override: Partial<TextTemplateEntity> = {}): TextTemplateEntity {
        const attr = { ...this, ...override };
        return Object.assign(new TextTemplateEntity(), attr);
    }
}

export function TextTemplateEntityFromBackend(res: TextTemplateResponseObject): TextTemplateEntity {

    return new TextTemplateEntity(
        res.Id && +res.Id,
        res.Name,
        res.Content,
        res.UserId && +res.UserId,
        res.PartnerId && +res.PartnerId,
        res.Private,
        res.TagIds,
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
        res.DeletedAt && GetTimeFromTimestamp(+res.DeletedAt),
    );
}
